import axios from "axios";

const module = {
  namespaced: true,
  state: {
    data: {},
  },
  mutations: {
    fetchData: (state, info) => {
      if(info) {
        state.data = info
      } else {
        state.data = {}
      }
    }
  },
  actions: {
    async fetchData ({commit}) {
      const response = await axios.get('user/astral-card')
      commit ('fetchData', response.data)
    },
    async requestCard () {
      await axios.post(`user/astral-card/request`)
    },
  }
}
export default module
